<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5412_132684)">
<path d="M7.99967 1.33333C8.87515 1.33333 9.74206 1.50577 10.5509 1.8408C11.3597 2.17583 12.0947 2.66689 12.7137 3.28595C13.3328 3.90501 13.8238 4.63994 14.1589 5.44878C14.4939 6.25761 14.6663 7.12452 14.6663 8M7.99967 1.33333V8M7.99967 1.33333C4.31778 1.33333 1.33301 4.3181 1.33301 8C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8M7.99967 1.33333C11.6816 1.33333 14.6663 4.3181 14.6663 8M14.6663 8L7.99967 8M14.6663 8C14.6663 9.05207 14.4173 10.0892 13.9397 11.0266C13.4621 11.964 12.7694 12.7751 11.9182 13.3934L7.99967 8" stroke="#080828" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_5412_132684">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
